export function fetchSimilarObjects(
    bounds, callback
) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `https://api.content.cian.ru/ajax/map/roundabout/?in_polygon[0]=${getFormattedBoundsQuery(bounds)}`);
    xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            callback(JSON.parse(xhr.responseText));
        }
    };
    xhr.send();
}

function getFormattedBoundsQuery(bounds) {
    const offset = 1;

    // tslint:disable-next-line:max-line-length
    return `${bounds[0][0 + offset].toFixed(6)}_${bounds[0][1 - offset].toFixed(6)},${bounds[0][0 + offset].toFixed(6)}_${bounds[1][1 - offset].toFixed(6)},${bounds[1][0 + offset].toFixed(6)}_${bounds[1][1 - offset].toFixed(6)},${bounds[1][0 + offset].toFixed(6)}_${bounds[0][1 - offset].toFixed(6)}`;
}


export async function fetchInfrastructure(
    id, bounds
) {
    const url = 'https://api.content.cian.ru/get-infrastructure-for-map/';
    const width = bounds.width ? bounds.width.toFixed() : 340;
    const height = bounds.height ? bounds.height.toFixed() : 225;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            aspectRatio: `${width}:${height}`,
            dealType: 'sale',
            offerType: 'flat',
            realtyOfferId: id
        })
    });
    if (!response.ok) {
        throw new Error('Infrastructure map request failed')
    }
    const data = await response.json();
    return data;
}

